import React from "react";
import "./SocialMedia.css";
import {socialMediaLinks} from "../../portfolio";

export default function socialMedia() {
  if (!socialMediaLinks.display) {
    return null;
  }
  return (
    <div className="social-media-container">
      <div className="social-media-div">

        {socialMediaLinks.cv ? (
          <a
            href={socialMediaLinks.cv}
            className="icon-button cv"
            target="_blank"
            rel="noopener noreferrer"
          >
             <i className="ai ai-cv"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.github ? (
          <a
            href={socialMediaLinks.github}
            className="icon-button github"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.linkedin ? (
          <a
            href={socialMediaLinks.linkedin}
            className="icon-button linkedin"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.gmail ? (
          <a
            href={`mailto:${socialMediaLinks.gmail}`}
            className="icon-button google"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-envelope"></i>
            <span></span>
          </a>
        ) : null}


        {socialMediaLinks.youtube ? (
          <a
            href={socialMediaLinks.youtube}
            className="icon-button youtube"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-youtube"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.gitlab ? (
          <a
            href={socialMediaLinks.gitlab}
            className="icon-button gitlab"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-gitlab"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.facebook ? (
          <a
            href={socialMediaLinks.facebook}
            className="icon-button facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.instagram ? (
          <a
            href={socialMediaLinks.instagram}
            className="icon-button instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.twitter ? (
          <a
            href={socialMediaLinks.twitter}
            className="icon-button twitter"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-twitter"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.medium ? (
          <a
            href={socialMediaLinks.medium}
            className="icon-button medium"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-medium"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.stackoverflow ? (
          <a
            href={socialMediaLinks.stackoverflow}
            className="icon-button stack-overflow"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-stack-overflow"></i>
            <span></span>
          </a>
        ) : null}

        

      {socialMediaLinks.scholar ? (
          <a
            href={socialMediaLinks.scholar}
            className="icon-button scholar"
            target="_blank"
            rel="noopener noreferrer"
          >
             <i className="ai ai-google-scholar"></i>
            <span></span>
          </a>
        ) : null}

      {socialMediaLinks.researchgate ? (
          <a
            href={socialMediaLinks.researchgate}
            className="icon-button researchgate"
            target="_blank"
            rel="noopener noreferrer"
          >
             <i className="ai ai-researchgate"></i>
            <span></span>
          </a>
        ) : null}

        {socialMediaLinks.kaggle ? (
          <a
            href={socialMediaLinks.kaggle}
            className="icon-button kaggle"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-kaggle"></i>
            <span></span>
          </a>
        ) : null}
      </div>

      <div className="arena-lab-container">
        <a
          href="https://arena-lab.org"
          target="_blank"
          rel="noopener noreferrer"
          className="arena-lab-button"
          title="Visit ARENA Lab"
        >
          <i className="fas fa-robot arena-lab-icon"></i>
          <span className="arena-lab-text">Visit ARENA-Lab</span>
        </a>
      </div>
    </div>
  );
}